import React from 'react';
import { ProgressBar, tokens } from '@welbe/web-design-system';

import { Container, Label, Square, Triangle, Wrapper } from './InfoCard.styles';
import getProgressColor from '../../../../../../helpers/getProgressColor';
import { BalloonHeartIcon } from '../BalloonHeartIcon/BalloonHeartIcon';

interface InfoCardProps {
	branchOfficeName: string;
	porcent: number;
	highlight?: boolean;
	onClick: () => void;
	totalEmployees: string;
	answeredEmployees: string;
	isNomCompleted: boolean;
}

export const InfoCard = ({
	branchOfficeName,
	porcent,
	highlight,
	onClick,
	totalEmployees,
	answeredEmployees,
	isNomCompleted,
}: InfoCardProps): JSX.Element => {
	const porcentColor = getProgressColor(porcent);

	return (
		<Wrapper onClick={onClick}>
			<Container
				className={highlight ? 'actived' : 'desactivated'}
				highlight={highlight}
			>
				<Label fontSize="14px" fontWeight={500}>
					{totalEmployees}
				</Label>
				<Label highlight={highlight}>{branchOfficeName}</Label>
				<ProgressBar
					backgroundColor={tokens.color_gray_medium}
					progressColor={porcentColor}
					percentValue={porcent}
					hasLabel
				/>
				<Label center fontSize="14px" fontWeight={500}>
					{answeredEmployees}
				</Label>
				<BalloonHeartIcon
					color={isNomCompleted ? tokens.color_success : undefined}
				/>
			</Container>
			{highlight ? <Triangle /> : <Square />}
		</Wrapper>
	);
};
